export enum EnumConfigEmpresa {
    TaxaServicoRecomendada = 800,
    ValorBandeira = 8002,
    KmMaximo = 8003,
    ValorPorKm = 8004,
    ProdutoEntrega = 8001,
    ClientePadrao = 326,
    PrefixoComanda = 804,
    soliClientesPorModeloTrabalho = 8022,
    ProdutoServico = 814
}